import React from "react";
import {
  Button,
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import { AccountingOrderTable } from "./AccountingOrderTable";
import { usePageStyles } from "../../pageStyles";
import { PageComponent } from "../../../core/navigation/types";
import { PageTitle } from "../../components/common/PageTitle";
import { AccountingOrderFilter } from "./AccountingOrderFilter";
import { LocalizationContext } from "../../../core/localization/Localization";
import { AccountingOrderButton } from "./AccountingOrderButton";

const AccountingOrderPage: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="accountingOrderTitle" />}
              action={<AccountingOrderActions />}
            />
            <Divider />
            <CardContent>
              <AccountingOrderTable userAccessRights={userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const AccountingOrderActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <AccountingOrderButton />
    </Grid>
    <Grid item>
      <AccountingOrderFilter />
    </Grid>
  </Grid>
);

export default AccountingOrderPage;
